/* global axios */
import ApiClient from './ApiClient';

class EmailCampaignTemplatesAPI extends ApiClient {
  constructor() {
    super('email_campaign_templates', { accountScoped: true });
  }

  list({ category } = {}) {
    const params = {};
    if (category) params.category = category;
    return axios.get(this.url, { params });
  }

  apply(id, { emailCampaignId } = {}) {
    return axios.post(`${this.url}/${id}/apply`, {
      email_campaign_id: emailCampaignId,
    });
  }
}

export default new EmailCampaignTemplatesAPI();
